<div class="content">
    <section class="subscriptions">
        <subscription></subscription>
    </section>

    @if(receipts()){
        <section class="receipts">
            <div class="spacer"></div>
            @for(receipt of receipts(); track receipt._id){
                <billing-receipt [receipt]="receipt"></billing-receipt>
                <div class="spacer"></div>
            }
        </section>
    } @else {
        <section class="loading">
            <object data="old/cloudigo_loader.svg" type="image/svg+xml"></object>
        </section>
    }
</div>